export enum ROOM_EDITED_FIELDS {
  PRICE = 'PRICE',
  DISCOUNT_PRICE = 'DISCOUNT_PRICE',
  STOCK = 'STOCK',
  CLOSED = 'CLOSED',
  DISCOUNT = 'DISCOUNT',
}

export type RoomEditedField =
  (typeof ROOM_EDITED_FIELDS)[keyof typeof ROOM_EDITED_FIELDS];
